angular.module('unica_agenda.agenda_routes', [
	'ui.router'
])

.config(function($stateProvider) {

	$stateProvider

		// AGENDA
		.state('app.agenda', {
			url: '/agenda',
			views: {
				'mainContent': {
					templateUrl: './modules/agenda/templates/agenda.html',
					controller: 'AgendaController'
				}
			},
			params: {
				need_auth: true
			}
		})

			// AGENDA LIST
			.state('app.agenda.list', {
				url: '/list/:event_id',
				views: {
					'agendaContent': {
						templateUrl: './modules/agenda/templates/list.html',
						controller: 'AgendaListController'
					}
				},
				ncyBreadcrumb: {
					label: 'Lista Tappe',
					parent: function($scope) {
						return 'app.event.detail({year: ' + $scope.year + ',id:' + $scope.event_id + '})';
					}
				}
			})


			// AGENDA CUSTOMIZE
			.state('app.agenda.customize', {
				url: '/customize/:event_id/:stage_id',
				views: {
					'agendaContent': {
						templateUrl: './modules/agenda/templates/customize.html',
						controller: 'AgendaCustomizeController'
					}
				},
				ncyBreadcrumb: {
					label: 'Personalizza',
					parent: function($scope) {
						return 'app.agenda.list({ event_id:' + $scope.event_id + '})';
					}
				}
			});


});

